import { MAZE_AUDIO_FILES } from '@/constants/audio';
import { useEffect, useRef } from 'react';

const PRELOAD_LINK_ID = 'maze-preload-bgm';

/**
 * Injects `<link rel="preload" as="audio">` for CloudFront BGM once gameplay is ready,
 * so the browser can start fetching before Howler constructs the Howl.
 */
export function useMazeBgmPreload(shouldPreload: boolean): void {
  const wasAttachedRef = useRef(false);

  useEffect(() => {
    if (!shouldPreload) {
      return;
    }
    if (wasAttachedRef.current || document.getElementById(PRELOAD_LINK_ID)) {
      wasAttachedRef.current = true;
      return;
    }

    const link = document.createElement('link');
    link.id = PRELOAD_LINK_ID;
    link.rel = 'preload';
    link.as = 'audio';
    link.href = MAZE_AUDIO_FILES.bgm;
    document.head.appendChild(link);
    wasAttachedRef.current = true;

    return () => {
      link.remove();
      wasAttachedRef.current = false;
    };
  }, [shouldPreload]);
}
